module.exports = __webpack_public_path__ + "img/letter.fb49a54f.jpg";